export default __webpack_public_path__ + "static/one_body_v2-58cd122e2bcbc374a1c12bad6fcf63a4.png";